import { useRef } from "react";

export default function useDebouncedFunction<T extends (...args: any[]) => any>(func: T, delay: number) {
	const ref = useRef<any>(null);

	return (...args: any[]) => {
		clearTimeout(ref.current);
		ref.current = setTimeout(() => func(...args), delay);
	};
}
